import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RaEditTooltipDirective } from '../../directives/ra-edit-tooltip/ra-edit-tooltip.directive';
import { CustomColorSwatchComponent } from '../custom-color-swatch/custom-color-swatch.component';
import {
    isCustomMediaFill,
    isHexMediaFill,
    MEDIA_FILL_CHOICES,
    MEDIA_FILL_TRANSPARENT,
    parseMediaFill,
} from '../../../../media-fill-options';

/**
 * Cor do fundo da mídia (a sobra em volta da foto inteira): as cores prontas em bolinhas e o
 * seletor livre, o mesmo arco-íris da cor do texto. Serve o painel da foto, do grupo e do
 * vídeo e a seção de imagens das configurações do documento.
 *
 * Emite `preview` enquanto o seletor livre é arrastado (quem usa mostra na hora, sem salvar)
 * e `choose` no clique numa bolinha ou quando o seletor livre fecha.
 */
@Component({
    selector: 'media-fill-field',
    templateUrl: 'media-fill-field.component.html',
    styleUrl: 'media-fill-field.component.scss',
    imports: [CustomColorSwatchComponent, RaEditTooltipDirective, TranslatePipe],
})
export class MediaFillFieldComponent {
    /** Cor efetiva mostrada, #rrggbb. */
    public value = input.required<string>();
    public disabled = input(false);

    public preview = output<string>();
    public choose = output<string>();

    public readonly choices = MEDIA_FILL_CHOICES;
    public readonly transparent = MEDIA_FILL_TRANSPARENT;

    /** Valor inicial do seletor livre: ele só entende #rrggbb (transparente abre no branco). */
    public pickerValue = computed(() => (isHexMediaFill(this.value()) ? this.value() : '#ffffff'));

    /** Cor fora da paleta: o seletor livre acende. */
    public isCustom = computed(() => isCustomMediaFill(this.value()));

    public select(hex: string): void {
        if (this.disabled() || hex === this.value()) return;
        this.choose.emit(hex);
    }

    public onCustomPreview(hex: string): void {
        const color = parseMediaFill(hex);
        if (color !== null) this.preview.emit(color);
    }

    /** O seletor livre fechou: salva já. */
    public onCustomChoose(hex: string): void {
        const color = parseMediaFill(hex);
        if (color !== null) this.choose.emit(color);
    }
}
